import { GTAG_PROPERTIES_KEY, SIGNUP_SEGMENT_PROPERTIES_KEY } from "./constants";

/**
 * This app sends AJAX as JSON, note it needs to set two attributes to do that:
 * - contentType so jQuery knows it's Json and does the right thing
 * - dataType so twilio-specific CSRF handling doesn't mangle your payload
 * see for more info https://code.hq.twilio.com/react/console-js/pull/96
 */

const __init__twilio = true;

$(function () {
    // create Arkose trigger element
    const $startArkose = $('#start-arkose');
    const isArkoseOn = $startArkose.length > 0;
    const $registrationFrom = $('@registration-form');
    const $signupButton = $('#signup-button');
    const csrfToken = $('meta[name=csrfToken]').attr('content')
    const $passwordGuidelines = $('#password-guidelines');
    const $emailAddr = $('#EmailAddr');
    const $partner = $registrationFrom.find('input[name="partner"]');
    const $preferredLanguage = $('#preferredLanguage');
    // password requirements div only exists if the user is in the password experiment
    const $isPasswordApiEnforced = $('#password-requirements').length > 0;
    // Time in ms to wait to see if Arkose finished loading.
    const ARKOSE_WAIT_TIME = 10 * 1000;

    function arkoseBabysitter() {
        function sendSignupAlert() {
            const data = {
                'message': 'arkose-timeout-enable-submit',
                'email': $emailAddr.val(),
            }
            $.ajax({
                url: '/signup/v2/alert',
                data: JSON.stringify(data),
                dataType: 'json',
                contentType: 'application/json',
                headers: {
                    'X-Twilio-Csrf': csrfToken,
                    'x-target-region': 'us1'
                },
                method: "POST",
            });
        }
        function didArkoseFail() {
            return $signupButton.attr('disabled') == 'disabled'
        }
        window.setTimeout( () => {
            if (didArkoseFail()) {
                sendSignupAlert();
            }
        }, ARKOSE_WAIT_TIME);
    }


    if (!$preferredLanguage.attr("value")) {
        if (window.location.hostname === 'jp.twilio.com') {
            $preferredLanguage.val('ja')
        } else {
            $preferredLanguage.val('en');
        }
    }

    /**
     * Setup the dropdown for selecting programming languages
     */
    $('#ProgrammingLanguage').selectize({
        create: false,
        placeholder: 'Choose your language'
    });

    const twilio = window.twilio || {};

    twilio.registrationForm = {
        validate: function () {
            twilio.analytics.event('/try-twilio', {
                'url': window.location.pathname
            });

            const baseValidationRules = {
              FirstName: {
                required: true,
                minlength: 1,
              },
              LastName: {
                required: true,
                minlength: 1,
              },
              EmailAddr: {
                required: true,
                email: true,
                minlength: 1,
              },
              Passwd: {
                required: true,
                minlength: 1,
                remote: {
                  depends: function () {
                    return $isPasswordApiEnforced;
                  },
                  param: {
                    url: "/signup/v2/password-check",
                    type: "post",
                    headers: {
                      "X-Twilio-Csrf": csrfToken,
                      "x-target-region": "us1",
                    },
                    dataFilter: function (respData, type) {
                      const parsedData = JSON.parse(respData);
                      const success = parsedData.success
                        ? parsedData.success
                        : null;
                      let errorMessages;
                      if (!success) {
                        const errors = parsedData.errors
                          ? parsedData.errors
                          : [];
                        errorMessages = $("<ul>")
                          .append(
                            errors.map((err) =>
                              $("<li>").text(err["devMessage"])
                            )
                          )
                          // turns the jquery element into a string while preserving the outer <ul> element
                          .prop("outerHTML");
                      }

                      if (errorMessages) {
                        return JSON.stringify(errorMessages);
                      }

                      return true;
                    },
                  },
                },
              },
              Tos: {
                required: true,
              },
            };

            const messages = {
                FirstName: {required: 'Required', minlength: 'Required'},
                LastName: {required: 'Required', minlength: 'Required'},
                EmailAddr: {
                    required: 'Required',
                    email: 'Enter a valid email',
                },
                Passwd: {
                    required: 'Required',
                    minlength: `Please enter at least ${baseValidationRules['Passwd'].minlength} characters`,
                },
                ProductInterest: {required: 'Required'},
                UseCase: {required: 'Required'},
                ProgrammingLanguage: {required: 'Required'},
                EstimatedUsageOptions: {required: 'Required'},
                Tos: {required: 'You must accept the Terms of Service to create a Twilio Account'},
            };

            /**
             * Validation will not occur on 'EmailAddr' and 'Passwd' elements on key typing events.
             * We only want to validate when the field loses focus.
             */
            const onkeyup = function (element) {
                if ($(element).attr('id') !== 'EmailAddr' && $(element).attr('id') !== 'Passwd') {
                    this.element(element);
                }
            };

            const errorPlacement = function (error, element) {
                const $el = $(element);

                if ($el.is('select')) {
                    const divElement = $el.parent().find('div.selectize-control');

                    if (divElement.length) {
                        error.insertAfter(divElement[0]);
                    }
                    return;
                }

                if ($el.is('#Tos')) {
                    const divElement = $el.parent().find('span.help-block');
                    divElement.replaceWith(error);
                    return;
                }

                if (element.next().is('span.help-block')) {
                    element.next().replaceWith(error);
                } else {
                    error.insertAfter(element);
                }
            };

            const highlight = function (element) {
                $(element).parent().addClass('has-error');
            };

            const unhighlight = function (element) {
                const $el = $(element);
                const hasErrors = $el.attr('id') in this.errorMap;

                if (!hasErrors) {
                    $el.parent()
                        .removeClass('has-error')
                        .find('.help-block').html('');
                }

                if ($el.is('[name="Passwd"]')) {
                    $passwordGuidelines.hide();
                }
            };

            const ignorePattern = ':hidden:not([class~=selectized]),:hidden > .selectized, .selectize-control .selectize-input input';

            $registrationFrom.validate({
                rules: baseValidationRules,
                messages: messages,
                errorElement: 'span',
                errorClass: 'help-block m-b-0',
                errorPlacement: errorPlacement,
                onkeyup: onkeyup,
                highlight: highlight,
                unhighlight: unhighlight,
                ignore: ignorePattern
            });
        },

        registerHandlers: function (onSubmit) {
            const regFormEl = document.getElementById("registration-form")
            regFormEl.addEventListener("submit", function (e) {
                e.preventDefault();
                twilio.alert.clear();

                if ($registrationFrom.valid()) {
                    onSubmit ? onSubmit() : twilio.registrationForm.postData();
                } else {
                    $signupButton.button('reset');
                }
            });
        },

        postData: function (addData = {}) {
            twilio.alert.clear();

            function onError(data) {
                let errorMessage = `An error occurred during signup.
                    Please contact <a href='mailto:help@twilio.com'>
                    help@twilio.com</a> if you are unable to continue.`;
                let sanitized = true;

                try {
                    // Not all failures will have an error message.
                    errorMessage = data.responseJSON.message.message;
                    sanitized = false;
                } catch (e) {
                    // nothing, safe to fail
                }

                twilio.alert.new('error', errorMessage, false, {clear: true, sanitized: sanitized});

                $signupButton
                    .removeAttr('disabled')
                    .removeClass('disabled')
                    .val('Get Started')
                    .text('Get Started');
            }

            function getAccountVerificationDomain() {
                const parsedUrl = new URL(window.location.href);
                const locationHost = parsedUrl.host.split(".");
                locationHost[0] = "console";
                const accountVerificationHost = locationHost.join(".");
                return `${parsedUrl.protocol}//${accountVerificationHost}`;
            }

            function onSuccess(data) {
                const ACCOUNT_EMAIL_VERIFICATION_PATH = "/account/verification/email";
                const ACCOUNT_GATE_VERIFICATION_PATH = "/account/verification/gate";
                const isConsoleZenRedirect = data.location.includes(ACCOUNT_EMAIL_VERIFICATION_PATH) ||
                    data.location.includes(ACCOUNT_GATE_VERIFICATION_PATH);

                twilio.analytics.pageView('/user/welcome');
                if (isConsoleZenRedirect) {
                    window.location = `${getAccountVerificationDomain()}${data.location}`;
                } else {
                    window.location = data.location ? data.location : '/signup/verify';
                }
            }

            const rawData = $registrationFrom.serializeArray();
            const formData = rawData.reduce(function (memo, item) {
                memo[item.name] = item.value;
                return memo;
            }, {});

            formData['CSRF'] = csrfToken;
            formData['Referer'] = document.referrer;

            let postData = Object.assign(formData, addData);
            postData = Object.assign(postData, { 
                gtag: getGTags(), 
                signupSegmentProperties: getSignupSegmentProperties()
            });
            const headers = {
              "X-Twilio-Csrf": csrfToken,
              "x-target-region": "us1"
            };

            $.ajax({
                type: 'POST',
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                url: $registrationFrom.attr('action'),
                data: JSON.stringify(postData),
                headers,
                success: onSuccess,
                error: onError
            });
        },

        ready: function () {
            $signupButton.removeAttr('disabled');
        },

        reset: function (response) {
            $signupButton.button('reset');
        },
    };

    const registrationFormEnforcement = {
        setup: function () {
            window.setupEnforcement = function (enforcement) {
                enforcement.setConfig({
                    selector: '#start-arkose',
                    onReady: registrationFormEnforcement.onReady,
                    onCompleted: registrationFormEnforcement.onComplete,
                    onHide: registrationFormEnforcement.onHide,
                });
            };
        },

        onReady: function () {
            twilio.registrationForm.ready();

            twilio.registrationForm.validate();
            const startArkose = function () {
                $startArkose.trigger('click');
            };
            twilio.registrationForm.registerHandlers(startArkose);
        },

        onComplete: function (response) {
            twilio.registrationForm.postData({captchaToken: response.token});
        },

        onHide: function (response) {
            if (!response.completed) {
                twilio.registrationForm.reset();
            }
        }
    };

    function getGTags() {
      const visitorSid = getVisitorSid();
      return getLocalStoragePropertiesByVisitorSid(GTAG_PROPERTIES_KEY, visitorSid);
    }

    function getSignupSegmentProperties() {
        const visitorSid = getVisitorSid();
        return getLocalStoragePropertiesByVisitorSid(SIGNUP_SEGMENT_PROPERTIES_KEY, visitorSid);
      }

    function getVisitorSid() {
      return window.twilio && window.twilio.visitor && window.twilio.visitor.sid
        ? window.twilio.visitor.sid
        : null;
    }

    function getLocalStoragePropertiesByVisitorSid(propertiesKey, visitorSid) {
      const properties =  !!localStorage &&
        !!visitorSid &&
        !!localStorage.getItem(propertiesKey) ?
        localStorage.getItem(propertiesKey)
        : null;

        let userProperties = {};
        try {
          const allProperties = JSON.parse(properties);
          const extractedData = allProperties[visitorSid];
          userProperties = extractedData ? extractedData : {};
        } catch (error) {
            userProperties = {};
        }
        return userProperties;
    }
    
    if (isArkoseOn) {
        registrationFormEnforcement.setup();
        arkoseBabysitter();
    } else {
        twilio.registrationForm.ready();
        twilio.registrationForm.validate();
        twilio.registrationForm.registerHandlers();
    }
});



// WEBPACK FOOTER //
// ./src/js/try-twilio.js